<template>
  <div class="text">{{ text }}</div>
</template>
<script>
export default {
  data() {
    return {
      text: "",
    };
  },
  props: {
    row: Object,
    index: Number,
  },
  methods: {
    accAdd(arg1, arg2) {
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    getDataRemark(rows) {
      let somethingElseList = 0;
      let workshopDailyDetailsList = 0;
      for (let index = 0; index < rows.somethingElseList.length; index++) {
        somethingElseList = this.accAdd(
          rows.somethingElseList[index].value,
          somethingElseList
        );
      }
      for (
        let index = 0;
        index < rows.workshopDailyDetailsList.length;
        index++
      ) {
        workshopDailyDetailsList = this.accAdd(
          rows.workshopDailyDetailsList[index].actualWorkingHours,
          workshopDailyDetailsList
        );
      }
      let allTime = this.accAdd(somethingElseList, workshopDailyDetailsList);
      if (allTime < 8) {
        this.text = "工时<8小时";
      }
    },
  },
  mounted() {
    this.getDataRemark(this.row);
  },
};
</script>
<style scoped>
.text {
    color: red;
}
</style>